import { render, staticRenderFns } from "./SchoolSubject.vue?vue&type=template&id=5d58fb94&scoped=true"
import script from "./SchoolSubject.vue?vue&type=script&lang=js"
export * from "./SchoolSubject.vue?vue&type=script&lang=js"
import style0 from "./SchoolSubject.vue?vue&type=style&index=0&id=5d58fb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58fb94",
  null
  
)

export default component.exports